import React, { PureComponent } from 'react';
import { map, cloneDeep, remove, uniqBy, isEmpty, get, isFunction } from 'lodash';
import { Tag, Popconfirm, Button, Card, message } from 'antd';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { ProductSelector } from '../../tools/link-selector/product-selector';
import ExportJsonExcel from 'js-export-excel';
import { ShowProductsUploadButton } from '../../../../components';

export class ShowProducts extends PureComponent<any> {
    removeProduct = (item) => {
        const { onChange, value } = this.props;
        let newValue = cloneDeep(value);
        remove(newValue, { id: item.id });
        onChange(newValue);
    };

    clearAll = () => {
        const { onChange } = this.props;
        onChange([]);
    };

    changeTarget = (selected) => {
        const { onChange, value } = this.props;
        onChange(uniqBy(value.concat(selected), 'id'));
    };

    renderProducts(products) {
        const isDragDropDisabled = products.length === 1;
        return (
            <DragDropContext onDragEnd={this.onDragEnd}>
                <Droppable isDropDisabled={isDragDropDisabled} droppableId="product-list">
                    {(provided) => (
                        <div ref={provided.innerRef} {...provided.droppableProps}>
                            {map(products, (item, index) =>
                                this.renderProduct(item, index, isDragDropDisabled)
                            )}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        );
    }

    handleExport = (value: any) => {
        if (value?.length) {
            const exportData = value.map((item, index) => ({
                code: index + 1,
                sku: item?.sku,
                type: 'SALES',
            }));
            // 直接导出文件
            let option: any = {}; //option代表的就是excel文件
            option.fileName = '商品导出数据'; //excel文件名称
            option.datas = [
                {
                    sheetData: exportData, //excel文件中的数据源
                    sheetName: 'Sheet1', //excel文件中sheet页名称
                    sheetFilter: ['code', 'sku', 'type'], //excel文件中需显示的列数据
                    sheetHeader: ['行号', 'SKU编码', '上下架状态（SALES-上架，NOT_SALES-下架）'], //excel文件中每列的表头名称
                    columnWidths: ['4', '11', '18'],
                },
            ];
            let toExcel = new ExportJsonExcel(option); //生成excel文件
            toExcel.saveExcel(); //下载excel文件
            message.success('导出成功！');
        } else {
            message.warning('请先选择商品！');
        }
    };

    renderProduct = (item, index, isDragDisabled) => {
        const removeProduct = this.removeProduct;
        return (
            <Draggable
                isDragDisabled={isDragDisabled}
                draggableId={'product-' + index}
                key={index}
                index={index}
            >
                {(provided) => {
                    return (
                        <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                        >
                            {/* <div className="product-i" style={{ width: 300, marginBottom: 15, paddingLeft: 15, paddingBottom: 15, background: '#cccccc' }}>
                                <p className='product-text'>SKU: {item.sku}</p>
                                <p className='product-text'>价格: {item.price}</p>
                                <p className='product-text'>商品名: {item.name}</p>
                            </div> */}
                            {/* <Card title={item.name} className="product-i" extra={<Button onClick={() => removeProduct(item)}>删除</Button>} style={{ width: 300, marginBottom: 15 }}>
                                <p className='product-text'>SKU: {item.sku}</p>
                                <p className='product-text'>价格: {item.price}</p>
                            </Card> */}
                            <Tag
                                key={item.id}
                                closable
                                onClose={() => removeProduct(item)}
                                className="product-i"
                            >
                                <p className="product-text">
                                    商品名: {item.name} SKU: {item.sku} 价格: {item.price}
                                </p>
                                {/* <p className='product-text'>价格: {item.price}</p>
                                <p className='product-text'>商品名: {item.name}</p> */}
                                {/* {item.name} */}
                            </Tag>
                        </div>
                    );
                }}
            </Draggable>
        );
    };
    onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
        const { value, onChange } = this.props;
        let newValue = cloneDeep(value);
        const startIndex = result.source.index;
        const endIndex = result.destination.index;
        const [removed] = newValue.splice(startIndex, 1);
        newValue.splice(endIndex, 0, removed);

        onChange(cloneDeep(newValue));
    };
    toggleUploadModalFun = (data) => {
        this.setState({
            showUploadModal: !this.state.showUploadModal,
        });
        if (data) {
            // console.log('我有值啦',data)
            const { onChange, value } = this.props;
            onChange(uniqBy(value.concat(data), 'id'));
        }
    };
    state = {
        showUploadModal: false,
    };
    render() {
        const { value, selector = {} } = this.props;
        const hasProducts = !isEmpty(value);
        const productsProps = {
            value: value,
            onChange: this.changeTarget,
            type: 'Multi' as const,
        };
        console.log('show-products props:', this.props);
        const customRenderSelector = get(selector, 'multiProduct.render');
        const isPointProductsModal =
            get(selector, 'multiProduct.modalConfig').title.indexOf('积分') > -1;
        // console.log('我是积分商品吗',isPointProductsModal)
        let { showUploadModal } = this.state;
        let uploadPropsObj = {
            showUploadModal: showUploadModal,
            toggleUploadModal: this.toggleUploadModalFun,
            type: isPointProductsModal ? 'FK_POINTS' : '',
        };
        return (
            <div className="products-show">
                {this.renderProducts(value)}
                {hasProducts && (
                    <Popconfirm
                        title="确定清空商品吗?"
                        onConfirm={this.clearAll}
                        okText="确定"
                        cancelText="取消"
                    >
                        <Button className="show-action" type={'link'}>
                            清空商品
                        </Button>
                    </Popconfirm>
                )}
                {isFunction(customRenderSelector) ? (
                    customRenderSelector(productsProps)
                ) : (
                    <ProductSelector
                        modalConfig={get(selector, 'multiProduct.modalConfig', {})}
                        contentConfig={get(selector, 'multiProduct.contentConfig', {})}
                        {...productsProps}
                    />
                )}
                <Button className="show-action" type={'link'} onClick={this.toggleUploadModalFun}>
                    批量导入商品
                </Button>
                <Button
                    className="show-action"
                    type={'link'}
                    onClick={() => {
                        this.handleExport(value);
                    }}
                >
                    批量导出商品
                </Button>

                {this.state.showUploadModal && <ShowProductsUploadButton {...uploadPropsObj} />}
            </div>
        );
    }
}
